import { render, staticRenderFns } from "./Family.vue?vue&type=template&id=3e419b52&scoped=true"
import script from "./Family.vue?vue&type=script&lang=js"
export * from "./Family.vue?vue&type=script&lang=js"
import style0 from "./Family.vue?vue&type=style&index=0&id=3e419b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e419b52",
  null
  
)

export default component.exports